import signin from './components/auth/reducer'

const auth = { signin }
export {
  auth
}